import { render, staticRenderFns } from "./selectcategory.vue?vue&type=template&id=0588b5e5&"
import script from "./selectcategory.vue?vue&type=script&lang=js&"
export * from "./selectcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports